module.exports = __webpack_public_path__ + "media/img/uploads/tbd-video-player-d3e164c3f34f7742fd27a06d15e19c45.png";